/* eslint-disable no-console */
import Promise from 'bluebird'
import request from 'superagent'

import Auth from './auth'

import store from 'state/index.js'
import { API_EXECUTE, API_EXECUTE_COMPLETED } from 'state/action-types'

const api = {}

function logApiResult(err, res) {
  // Optimize for production
  if (process.env.NODE_ENV === 'production') return
  // Django responses return proper error messages in body so we always
  // resolve the response (successfully), and then check for errors where
  // call is made. Below is just for logging purposes
  const url = res.req.url
  if (err) {
    console.groupCollapsed(`%c${url}%c - ${err}`, 'color: #b70a0a; font-weight: bold;', 'font-weight:normal; color:#444;')
    console.log(res)
  } else {
    console.groupCollapsed(`%c${url}`, 'color: #246cca; font-weight: bold;')
    console.log(res)
  }
  console.groupEnd()
}


/**
 * GET request
 * @param  {Boolean} options.url   [description]
 * @param  {Object}  options.query [description]
 * @return {[type]}                [description]
 */
api.get = ({ url = false, query = {}, isPrivate = true }) => {
    // .set(`Authorization`, isPrivate ? `Bearer ${token}` : null)
  //store.dispatch({ type: API_EXECUTE })
  return new Promise((resolve, reject)=>{
    request
      .get(url)
      .query(query)
      .set('Accept', 'application/json')
      .set('Authorization', isPrivate ? Auth.validateSession() : null)
      //.set('Authorization', isPrivate ? true : null)
      .end(function(err, res){
        logApiResult(err, res)
        resolve(res)
      })
    })
}

api.post = ({ url = false, data = {}, isPrivate = true, contentType = 'application/x-www-form-urlencoded' }) => {
  return new Promise((resolve, reject)=>{
    request
      .post(url)
      .send(data)
      .type('form')
      .set(`Authorization`, isPrivate ? Auth.validateSession() : null)
      .set('Content-Type', contentType)
      // .set('Accept', 'application/json')
      .end(function(err, res){
        logApiResult(err, res)
        // Based on jsonapi.org - Below will always contain 'errors' array or data object|array
        // if (!res.body.data && !res.body.errors)
        //   console.error(`${url}: Response not following specified format! Something may be broken`)
        resolve(res)
      })
  })
}

export default api



// WEBPACK FOOTER //
// ./services/api.js